import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import RestrictedView from '../../auth/RestrictedView'
import withUser from '../../auth/withUser'
import { i18n } from '../../index'
import MarketQuestionDialog from './MarketQuestionDialog'
import css from './marketQuestionPage.css'
import { fetchMarketQuestions } from './marketQuestionQueries'
import MarketQuestionTable from './MarketQuestionTable'
import type { MarketQuestion } from './marketQuestionTypes'

type MarketQuestionPageProps = Record<string, any>
type MarketQuestionPageState = {
  isDialogOpen: boolean
  data: MarketQuestion | null | undefined
}

@withUser
class MarketQuestionPage extends React.PureComponent<MarketQuestionPageProps, MarketQuestionPageState> {
  state = {
    isDialogOpen: false,
    data: null,
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      data: null,
    })
  }
  onEdit = (data: MarketQuestion) => {
    this.setState({
      data,
    })
    this.openDialog()
  }

  render() {
    const { isDialogOpen, data } = this.state
    return (
      <div className={css.component}>
        <div className={css.top}>
          <Typography variant='h6'>{i18n.t('admin.marketQuestion.pageTitle')}</Typography>
        </div>
        <Query<
          {
            marketQuestion: Array<MarketQuestion>
          },
          {}
        >
          query={fetchMarketQuestions}
        >
          {({ loading, error, data }) => (
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <MarketQuestionTable data={get(data, 'marketQuestions', [])} onEdit={this.onEdit} />
            </Loader>
          )}
        </Query>
        <MarketQuestionDialog data={data} isOpen={isDialogOpen} onClose={this.closeDialog} />
        <RestrictedView requiredPermission='manage_ownStation'>
          <div className={css.bottom}>
            <Button onClick={this.openDialog} variant='contained' color='primary'>
              {i18n.t('buttons.create')}
            </Button>
          </div>
        </RestrictedView>
      </div>
    )
  }
}

export default MarketQuestionPage
